export default '/src/assets/webgl/pedro/audios/global_intro.mp3'